import React, { useContext } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { useCartAdd } from 'src/hooks/useCartAdd';
import type { Product } from 'src/models/product/schema';
import { BrandsContext } from 'src/stores/Brands';
import { I18nContext } from 'src/stores/I18n';
import { MakersContext } from 'src/stores/Makers';
import { brandName } from 'src/utils/brandName';
import { pushDataLayerForSingleProduct } from 'src/utils/createDataLayerObject';
import { getMakerName } from 'src/utils/productHelper';
import styles from './index.module.scss';

type Props = {
  product: Product;
  section: string;
  targetAttributionToken?: string;
};

export const CartButton: React.FC<Props> = ({ product, section, targetAttributionToken }) => {
  const localeResources = useContext(I18nContext);
  const makers = useContext(MakersContext);
  const brands = useContext(BrandsContext);
  const { onAddToCart } = useCartAdd({ targetAttributionToken });
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, clickedSection: string) => {
    e.preventDefault();
    e.stopPropagation();
    // eコマース_カート追加イベントの送信
    pushDataLayerForSingleProduct(
      'add_to_cart',
      product,
      getMakerName(product.makerId || 0, makers),
      brandName(product, brands),
      1
    );
    onAddToCart(product, 1, clickedSection);
  };
  return (
    <button className={styles.cartButton} onClick={(e) => handleClick(e, section)}>
      <NextImage
        src="/kaimono/images/cart/cart.svg"
        width={20}
        height={20}
        alt={localeResources.cart.addToCart}
        className="addCartFromList"
      />
    </button>
  );
};
